import styles from "./index.module.scss";

function formatTime(seconds: number): string {
  // 计算小时数
  const hours = Math.floor(seconds / 3600);
  // 计算剩余秒数中的分钟数
  const minutes = Math.floor((seconds % 3600) / 60);
  // 剩余秒数
  const secs = seconds % 60;

  // 将小时、分钟、秒数格式化为两位数
  const hh = String(hours).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(Math.floor(secs)).padStart(2, '0');

  // 拼接成hh:mm:ss格式
  return `${hh}:${mm}:${ss}`;
}

type TimeLabelProps = {
  value: number;  // s
  offset?: number;
}

const TimeLabel = (props: TimeLabelProps) => {
  const {
    value,
    offset = 0,
  } = props;

  return (
    <span
      style={{
        transform: `translate3d(-50%, calc(100% + 2px + ${offset}px), 0)`
      }}
      className={styles["time_label"]}
    >
      {formatTime(value)}
    </span>
  )
}

export default TimeLabel;